<template>
    <ValidationObserver ref="createDomainForm" v-slot="{ passes }">
        <Alert :error="error" />
        <form @submit.prevent="passes(createDomain)" class="-mb-4">
            <FormFieldSet>
                <FormInput
                    v-model="form.domain"
                    type="text"
                    rules="required"
                    name="domain"
                    placeholder="example.com"
                />
                <div class="flex justify-end">
                    <FormButton type="submit" :loading="loading">
                        {{ $t("forms.buttons.create_domain") }}
                    </FormButton>
                </div>
            </FormFieldSet>
        </form>
    </ValidationObserver>
</template>

<script>
import { DomainStoreNamespacedTypes } from "@/store/modules/domain";

import { ValidationObserver } from "vee-validate";
import Alert from "@/components/ui/Alert";
import FormInput from "@/components/forms/fields/FormInput";
import FormFieldSet from "@/components/forms/fields/FormFieldSet";
import FormButton from "@/components/forms/fields/FormButton";

export default {
    components: {
        FormButton,
        FormFieldSet,
        Alert,
        ValidationObserver,
        FormInput,
    },
    data: () => ({
        form: {
            domain: null,
        },
    }),
    computed: {
        /**
         * @type {Boolean}
         */
        loading() {
            return this.$store.getters[
                DomainStoreNamespacedTypes.getters.DOMAINS_LOADING
            ]();
        },

        /**
         * @type {Object}
         */
        error() {
            return this.$store.getters[
                DomainStoreNamespacedTypes.getters.DOMAINS_ERROR
            ]();
        },
    },
    methods: {
        /**
         * Sends authentication credentials to the server.
         */
        createDomain() {
            this.$store
                .dispatch(
                    DomainStoreNamespacedTypes.actions.CREATE_DOMAIN,
                    this.form
                )
                .then(() => {
                    if (!this.error) {
                        this.$emit("saved");
                    }
                });
        },
    },
    beforeCreate() {
        this.$store.commit(
            DomainStoreNamespacedTypes.mutations.SET_DOMAINS_ERROR,
            null
        );
    },
};
</script>
